import { CodStatus, Roles } from '@cod-monorepo/interfaces';

export const statusRoleMapping = {
    [CodStatus.CREDIT_REVIEW]: Roles.CREDIT_REVIEWER,
    [CodStatus.FINANCE_REVIEW]: Roles.FINANCE_MANAGER,
    [CodStatus.INVESTIGATION]: Roles.INVESTIGATOR,
    [CodStatus.MANAGER_REVIEW]: Roles.MANAGER,
    [CodStatus.CLOSED]: Roles.ADMIN,
    [CodStatus.SUBMITTED]: Roles.ADMIN
};
